import axios from "axios";
import qs from 'qs';
import { ls } from "@/utils/util"

const http = axios.create({ timeout: 28800 * 1000, });
http.interceptors.request.use(

    (config) => {
        if (ls.get('token')) {
            config.headers = {
                Authorization: 'Bearer ' + ls.get('token') || ''
                // Authorization: ''
            }
        }
        if (config.method === 'post') {
            config.headers['content-type'] = 'application/x-www-form-urlencoded'
            config.data = qs.stringify(config.data)
        }
        if (config.method === 'post_json') {
            config.headers['content-type'] = 'application/json;charset=UTF-8'
            config.method = 'post'
        }
        if (config.method === 'post_upload') {
            config.headers['content-type'] = 'application/x-www-form-urlencoded'
            config.method = 'post'
            config.responseType = 'blob'
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
);
http.interceptors.response.use(
    (res) => {
        return res
    },
    (error) => {
        return Promise.reject(error)
    }
);
export default http
